import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgJackpot = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.96904 0.66665H3.47368C3.25078 0.66665 3.04263 0.778051 2.91898 0.963516L0.111967 5.17404C-0.0464783 5.41171 -0.0359074 5.72391 0.138252 5.95032L7.15579 15.0731C7.28199 15.2372 7.47723 15.3333 7.68421 15.3333C7.89119 15.3333 8.08643 15.2372 8.21263 15.0731L15.2302 5.95032C15.4043 5.72391 15.4149 5.41171 15.2565 5.17404L12.4494 0.963516C12.3258 0.778051 12.1176 0.66665 11.8947 0.66665H8.39938C8.39011 0.666456 8.38082 0.666455 8.37152 0.66665H6.9969C6.9876 0.666455 6.97831 0.666456 6.96904 0.66665ZM7.97394 1.99998H7.39448L5.95588 4.87718H9.41254L7.97394 1.99998ZM9.46465 1.99998L10.9033 4.87718H13.4561L11.5379 1.99998H9.46465ZM13.3478 6.21051H10.9836L9.40745 11.333L13.3478 6.21051ZM7.68421 12.3997L9.58859 6.21051H5.77983L7.68421 12.3997ZM4.46517 4.87718L5.90377 1.99998H3.83047L1.91235 4.87718H4.46517ZM2.02058 6.21051H4.38481L5.96097 11.333L2.02058 6.21051Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgJackpot)
const IconSvgJackpot = createIcon(ForwardRef, 'SvgJackpot')
export default IconSvgJackpot
